/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export var OrderByDirection;
(function (OrderByDirection) {
  OrderByDirection["Asc"] = "asc";
  OrderByDirection["Desc"] = "desc";
})(OrderByDirection || (OrderByDirection = {}));
import axios from "axios";
export var ContentType;
(function (ContentType) {
  ContentType["Json"] = "application/json";
  ContentType["JsonApi"] = "application/vnd.api+json";
  ContentType["FormData"] = "multipart/form-data";
  ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
  ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
  instance;
  securityData = null;
  securityWorker;
  secure;
  format;
  constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }
  setSecurityData = (data) => {
    this.securityData = data;
  };
  mergeRequestParams(params1, params2) {
    const method = params1.method || (params2 && params2.method);
    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase()]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }
  stringifyFormItem(formItem) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }
  createFormData(input) {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent = property instanceof Array ? property : [property];
      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }
      return formData;
    }, new FormData());
  }
  request = async ({ secure, path, type, query, format, body, ...params }) => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;
    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body);
    }
    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }
    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}
/**
 * @title ProFit Gym core backend
 * @version 1.17.2
 * @contact
 */
export class CoreApi extends HttpClient {
  /**
   * No description
   *
   * @tags App
   * @name AppControllerRoot
   * @request GET:/
   */
  appControllerRoot = (params = {}) =>
    this.request({
      path: `/`,
      method: "GET",
      ...params,
    });
  auth = {
    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerLogin
     * @request POST:/auth/login
     */
    authControllerLogin: (data, params = {}) =>
      this.request({
        path: `/auth/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerRefresh
     * @request POST:/auth/refresh
     */
    authControllerRefresh: (data, params = {}) =>
      this.request({
        path: `/auth/refresh`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  gyms = {
    /**
     * No description
     *
     * @tags Gyms
     * @name GymControllerListGyms
     * @request GET:/gyms
     */
    gymControllerListGyms: (params = {}) =>
      this.request({
        path: `/gyms`,
        method: "GET",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags Arrangements
     * @name ArrangementControllerGetByGym
     * @request GET:/gyms/{gymId}/arrangements
     */
    arrangementControllerGetByGym: (gymId, params = {}) =>
      this.request({
        path: `/gyms/${gymId}/arrangements`,
        method: "GET",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags Arrangements
     * @name ArrangementControllerGetHighlightedByGym
     * @request GET:/gyms/{gymId}/arrangements/highlighted
     */
    arrangementControllerGetHighlightedByGym: (gymId, params = {}) =>
      this.request({
        path: `/gyms/${gymId}/arrangements/highlighted`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  lessons = {
    /**
     * No description
     *
     * @tags Lessons
     * @name LessonControllerPaginateLessons
     * @request GET:/lessons
     */
    lessonControllerPaginateLessons: (query, params = {}) =>
      this.request({
        path: `/lessons`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags Lessons
     * @name LessonControllerGetLessonById
     * @request GET:/lessons/{lessonId}
     */
    lessonControllerGetLessonById: (lessonId, query, params = {}) =>
      this.request({
        path: `/lessons/${lessonId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  groupLessons = {
    /**
     * No description
     *
     * @tags Group Lessons
     * @name GroupLessonControllerGetGroupLessons
     * @request GET:/group-lessons
     */
    groupLessonControllerGetGroupLessons: (query, params = {}) =>
      this.request({
        path: `/group-lessons`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags Group Lessons
     * @name GroupLessonControllerFindById
     * @request GET:/group-lessons/{groupLessonId}
     */
    groupLessonControllerFindById: (groupLessonId, params = {}) =>
      this.request({
        path: `/group-lessons/${groupLessonId}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  intake = {
    /**
     * No description
     *
     * @tags Intake
     * @name IntakeRegistrationControllerRegister
     * @request POST:/intake/register
     */
    intakeRegistrationControllerRegister: (data, params = {}) =>
      this.request({
        path: `/intake/register`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags Intake
     * @name IntakeFlowControllerHandle
     * @request POST:/intake/flow/appointment
     */
    intakeFlowControllerHandle: (params = {}) =>
      this.request({
        path: `/intake/flow/appointment`,
        method: "POST",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags Intake
     * @name IntakeCalendarControllerGetCalendar
     * @request GET:/intake/cal/{code}
     */
    intakeCalendarControllerGetCalendar: (code, params = {}) =>
      this.request({
        path: `/intake/cal/${code}`,
        method: "GET",
        ...params,
      }),
  };
  webhooks = {
    /**
     * No description
     *
     * @tags Webhooks
     * @name TwilioInboundWebhookControllerReceive
     * @request POST:/webhooks/twilio/whatsapp
     */
    twilioInboundWebhookControllerReceive: (params = {}) =>
      this.request({
        path: `/webhooks/twilio/whatsapp`,
        method: "POST",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags Webhooks
     * @name TwilioStatusWebhookControllerReceive
     * @request POST:/webhooks/twilio/whatsapp/status
     */
    twilioStatusWebhookControllerReceive: (params = {}) =>
      this.request({
        path: `/webhooks/twilio/whatsapp/status`,
        method: "POST",
        ...params,
      }),
    /**
     * No description
     *
     * @tags Webhooks
     * @name MetaWebhookControllerVerify
     * @request GET:/webhooks/meta/whatsapp
     */
    metaWebhookControllerVerify: (query, params = {}) =>
      this.request({
        path: `/webhooks/meta/whatsapp`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags Webhooks
     * @name MetaWebhookControllerReceive
     * @request POST:/webhooks/meta/whatsapp
     */
    metaWebhookControllerReceive: (params = {}) =>
      this.request({
        path: `/webhooks/meta/whatsapp`,
        method: "POST",
        ...params,
      }),
  };
  arrangements = {
    /**
     * No description
     *
     * @tags Arrangements
     * @name ArrangementControllerGetArrangements
     * @request GET:/arrangements
     */
    arrangementControllerGetArrangements: (query, params = {}) =>
      this.request({
        path: `/arrangements`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags Arrangements
     * @name ArrangementControllerGetHighlighted
     * @request GET:/arrangements/highlighted
     */
    arrangementControllerGetHighlighted: (params = {}) =>
      this.request({
        path: `/arrangements/highlighted`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}
